var map = {
	"./bs.json": 1064,
	"./da.json": 1065,
	"./de.json": 1066,
	"./en-US.json": 1067,
	"./es.json": 1068,
	"./fi.json": 1069,
	"./fr.json": 1070,
	"./hu.json": 1071,
	"./it.json": 1072,
	"./ja.json": 1073,
	"./nl.json": 1074,
	"./pt.json": 1075,
	"./tr.json": 1076
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 420;